import OpenInvoices from './OpenInvoices';
import { IInitialState } from 'src/store/initialState';
import { connect } from 'react-redux';
import {
  datesFilterSel,
  statusFilterSel,
  invoicesActions,
  sortFilterSel,
  oldestInvoiceDebitSel,
  oldestInvoiceCreditSel
} from 'src/store/modules/invoices';
import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';
import actions from 'src/store/modules/invoices/actions';
import {
  pageNumberSel,
  pageSizeSel,
  totalElementsSel,
  totalPagesSel,
  getInvoicesIsPendingSel,
  invoiceDebitSel,
  invoiceCreditSel
} from 'src/store/modules/invoices';
const mapStateToProps = (state: IInitialState) => ({
  datesFilter: datesFilterSel(state),
  statusFilter: statusFilterSel(state),
  sortFilter: sortFilterSel(state),
  totalDebit: invoiceDebitSel(state),
  totalCredit: invoiceCreditSel(state),
  pagination: {
    pageNumber: pageNumberSel(state),
    pageSize: pageSizeSel(state),
    totalElements: totalElementsSel(state),
    totalPages: totalPagesSel(state),
    getInvoicesIsPending: getInvoicesIsPendingSel(state)
  }
});

const mapDispatchToProps = (dispatch: any) => ({
  getInvoices: (filters: IFiltersInvoice, pagination: IPaginationInvoice) =>
    dispatch(actions.getInvoices(filters, pagination)),
  getOriginalInvoices: () => dispatch(actions.getOriginalInvoices()),
  getOldestInvoices: () => dispatch(actions.getOldestInvoices())
});
// export const pureComponent = DataTable;
// export default withRouter(EnhancedTable);
export default connect(mapStateToProps, mapDispatchToProps)(OpenInvoices);

interface IEnhancedProps {
  getInvoices(): void;
  getOriginalInvoices(): void;
  getOldestInvoices(): void;
}
